import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type {
  SeoInfoQuery,
  SEOInfoVo,
  EntityDescVo,
  ProductSEOModelVo,
  BlogArticleVo,
  TotalQuery,
  TotalVo,
  ReviewQuery,
  ReviewVo,
  HelpfulVo,
  HelpfulQuery
} from './types.ts';

/**
 * 获取SEO相关信息
 */
export const getSeoInfo = (params: SeoInfoQuery): AxiosPromise<SEOInfoVo> => {
  return request({
    url: '/product/api/seo/info',
    method: 'get',
    params
  });
};
// 获取seo商品描述信息

export const getSeoEntityDesc = (params: { entityId: string }): AxiosPromise<EntityDescVo> => {
  return request({
    url: '/product/api/seo/entityDesc',
    method: 'get',
    params
  });
};

// 根据路由查询SEO模块信息
export const productSeoModelInfo = (params: { routeUrl: string }): AxiosPromise<ProductSEOModelVo> => {
  return request({
    url: '/product/api/seo/productSeoModelInfo',
    method: 'get',
    params
  });
};

// 查询博客列表
export const blogArticleList = (params: { spuId: string }): AxiosPromise<BlogArticleVo[]> => {
  return request({
    url: '/product/api/seo/blogArticleList',
    method: 'get',
    params
  });
};

// 查询offer评论列表
export const getOfferReview = (params: { offerId: any }): AxiosPromise<unknown[]> => {
  return request({
    url: '/product/urlMapping/game-service/getOfferReview',
    method: 'get',
    params
  });
};
// 分页查询店铺评价-产品页统计
export const commonTotal = (params: TotalQuery): AxiosPromise<TotalVo> => {
  return request({
    url: '/api/order/review/product/total',
    method: 'get',
    params
  });
};

// 分页查询店铺评价-产品页
export const commonPage = (params: ReviewQuery): AxiosPromise<ReviewVo[]> => {
  return request({
    url: '/api/order/review/product/page',
    method: 'get',
    params
  });
};
// 分页查询店铺评价-点helpfu
export const commonHelpful = (data: HelpfulQuery): AxiosPromise<HelpfulVo> => {
  return request({
    url: '/api/order/review/helpful',
    method: 'post',
    data
  });
};
